// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { Batch, BatchInfo, CPrincipal, OrganizationMember, OrganizationMemberRole, OrganizationPermissions, TD_MemberProfile, TID, UProfileIdentifier } from "./TypeDefinitions.ts"

export interface Profiles {
  findProfiles(identifiers: UProfileIdentifier[]): Promise<TD_MemberProfile[]>

  getOrganizationPermissions(): Promise<OrganizationPermissions>

  getProfilePreference(key: string): Promise<string | null>

  listOrganizationMembers(batchInfo: BatchInfo): Promise<Batch<OrganizationMember>>

  listProfiles(batchInfo: BatchInfo, query: string): Promise<Batch<TD_MemberProfile>>

  me(): Promise<CPrincipal>

  profile(profile: UProfileIdentifier): Promise<TD_MemberProfile>

  removeOrganizationMember(profileId: TID): Promise<void>

  resolvePrincipals(pids: TID[]): Promise<Pair<TID, CPrincipal>[]>

  setOrganizationMemberRole(profileId: TID, role: OrganizationMemberRole): Promise<void>

  setProfilePreference(key: string, value: string | null): Promise<void>
}

export class ProfilesClient implements Profiles {
  constructor(private service: ApiService) {}

  async findProfiles(identifiers: UProfileIdentifier[]): Promise<TD_MemberProfile[]> {
    return getResult(await this.service.rpc<TD_MemberProfile[], never>("Profiles/findProfiles", {
      identifiers: identifiers,
    }))
  }

  async getOrganizationPermissions(): Promise<OrganizationPermissions> {
    return getResult(await this.service.rpc<OrganizationPermissions, never>("Profiles/getOrganizationPermissions", {
    }))
  }

  async getProfilePreference(key: string): Promise<string | null> {
    return getResult(await this.service.rpc<string | null, never>("Profiles/getProfilePreference", {
      key: key,
    }))
  }

  async listOrganizationMembers(batchInfo: BatchInfo): Promise<Batch<OrganizationMember>> {
    return getResult(await this.service.rpc<Batch<OrganizationMember>, never>("Profiles/listOrganizationMembers", {
      batchInfo: batchInfo,
    }))
  }

  async listProfiles(batchInfo: BatchInfo, query: string): Promise<Batch<TD_MemberProfile>> {
    return getResult(await this.service.rpc<Batch<TD_MemberProfile>, never>("Profiles/listProfiles", {
      batchInfo: batchInfo,
      query: query,
    }))
  }

  async me(): Promise<CPrincipal> {
    return getResult(await this.service.rpc<CPrincipal, never>("Profiles/me", {
    }))
  }

  async profile(profile: UProfileIdentifier): Promise<TD_MemberProfile> {
    return getResult(await this.service.rpc<TD_MemberProfile, never>("Profiles/profile", {
      profile: profile,
    }))
  }

  async removeOrganizationMember(profileId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Profiles/removeOrganizationMember", {
      profileId: profileId,
    }))
  }

  async resolvePrincipals(pids: TID[]): Promise<Pair<TID, CPrincipal>[]> {
    return getResult(await this.service.rpc<Pair<TID, CPrincipal>[], never>("Profiles/resolvePrincipals", {
      pids: pids,
    }))
  }

  async setOrganizationMemberRole(profileId: TID, role: OrganizationMemberRole): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Profiles/setOrganizationMemberRole", {
      profileId: profileId,
      role: role,
    }))
  }

  async setProfilePreference(key: string, value: string | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Profiles/setProfilePreference", {
      key: key,
      value: value,
    }))
  }

}

